import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'
import { SchoolClassOptionTypes } from 'teacher-ui-client/components/base/select/school-class/options'
import type AssignmentsProductManageMyStudentsRoute from 'teacher-ui-client/assignments/product/manage/my-students/route'

export default class extends Controller<ModelFor<AssignmentsProductManageMyStudentsRoute>> {
  @tracked pageNumber = 1

  @tracked perPage = 20

  @tracked sortColumn = 'firstName'

  @tracked sortDirection = 'asc'

  @tracked selectedSchoolClassId: SchoolClassOptionTypes | string = SchoolClassOptionTypes.My

  @tracked selectedStudentId?: string

  queryParams = ['pageNumber', 'perPage', 'sortColumn', 'sortDirection', 'selectedSchoolClassId']

  get selectedStudent() {
    return this.model.allStudents?.find((s) => s.id === this.selectedStudentId)
  }

  @action
  goToStudent(id: string) {
    this.selectedStudentId = this.selectedStudentId === id ? undefined : id
  }

  @action
  selectSchoolClassId(id: SchoolClassOptionTypes | string) {
    this.selectedSchoolClassId = id
  }
}
